import type { CourseAccreditationByProfession } from "@brookbush/types";

import clsx from "clsx";
import { memo, useEffect, useState } from "react";

import AboutAccreditationTabPanel from "./AboutAccreditationTabPanel";
import { useCourseAccreditationsByProfession } from "~/hooks";

const AboutAccreditationsTabs = () => {
	const { accreditationsByProfession } = useCourseAccreditationsByProfession();
	const [selectedProfession, setSelectedProfession] =
		useState<CourseAccreditationByProfession>();

	useEffect(() => {
		setSelectedProfession(accreditationsByProfession[0]);
	}, [accreditationsByProfession]);

	return (
		<>
			<div className="mx-auto flex w-full max-w-max gap-2 overflow-scroll whitespace-nowrap rounded-full bg-slate-50 p-2 dark:bg-slate-700">
				{accreditationsByProfession.map((prof) => (
					<button
						onClick={() => setSelectedProfession(prof)}
						key={prof.slug}
						className={clsx(
							"rounded-full px-4 py-2 font-medium text-sm hover:bg-slate-50 sm:text-base dark:hover:bg-slate-600",
							{
								"dark:hover:!bg-slate-300 bg-white shadow-slate-200 shadow-xl dark:bg-slate-200 dark:text-slate-900 dark:shadow-slate-800":
									selectedProfession?.slug === prof.slug,
							},
						)}
					>
						{prof.title}
					</button>
				))}
			</div>

			<AboutAccreditationTabPanel profession={selectedProfession!} />
		</>
	);
};

export default memo(AboutAccreditationsTabs);
